import { UI_PRIMITIVE__text_area } from '@/components/ui/UI_PRIMITIVE__text_area';
import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { Key } from '@/enums/key';
import { use_ref_with_fallback } from '@/hooks/_base/use_ref_with_fallback';
import { HOOK__run_on_next_frame } from '@/hooks/HOOK__run_on_next_frame';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { EVENT_text_area } from '@/types/types';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { logi } from '@shared/utils/utils_logs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/*
 * COMPONENT
 */
interface PROPS {
  field_list: FIELD__list_token;
}

export function G_UI_FIELD_PROMPT__text_area({ field_list }: PROPS) {
  /*
   * STORE
   */
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { generation_current } = use_slice_generation(['generation_current']);

  const { graph } = generation_current.tool;

  /*
   * STATE
   */

  const ref_text_area = use_ref_with_fallback(ENUM__html_ref_stub.TEXT_AREA);

  const [input_value, set_input_value] = useState('');
  const [is_loading, set_is_loading] = useState(false);

  const run_on_next_frame = HOOK__run_on_next_frame();

  /*
   * EFFECTS
   */

  /*
   * EVENTS
   */

  function onChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    let value_string = e.target.value.toLowerCase();

    set_input_value(value_string);
  }

  async function onKeyDown(e: EVENT_text_area) {
    e.key == Key.Enter && (await on_pressed_enter(e));

    e.key == Key.Escape && (await on_pressed_escape(e));
  }

  async function on_pressed_escape(e: EVENT_text_area) {
    e.preventDefault();
    e.stopPropagation();

    ref_text_area.current.blur();
  }

  async function on_pressed_enter(e: EVENT_text_area) {
    e.preventDefault();
    e.stopPropagation();

    let value_string = input_value;
    set_input_value('');

    let tokens_new = FIELD__token.from_string_to_token_list(value_string, field_list);

    for (let token_new of tokens_new) {
      const token_saved = field_list.get_token_by_word_english(token_new.word_english.get_value());

      if (token_saved.is_stub()) {
        logi('todo: translate token');
        // let token_create_data = for_token_add_create_word_with_context(token_new.word_english, token_new.weight.get_value(), settings.tokens, !e.shiftKey);
        // request.tokens_data.push(token_create_data);
        let is_positive = !e.shiftKey;

        token_new.is_positive.set_value(is_positive);

        let index_to_insert_token = is_positive ? field_list.get_index_to_insert_token_positive() : field_list.get_index_to_insert_token_negative();

        console.log('index_to_insert_token', index_to_insert_token);

        field_list.items.insert_at(index_to_insert_token, token_new);
      } else {
        token_saved.is_hidden.set_value(false);
        token_saved.weight.set_value(token_new.weight.get_value());
        token_saved.is_positive.set_value(token_new.is_positive.get_value());
      }
    }

    field_list.field_name_and_path__fill_for_children();

    /*
     *
     */

    set_is_loading(true);

    await UTILS__graph_data.update_field(graph, field_list);

    set_is_loading(false);

    /*
     *
     */

    //wait till react updates
    run_on_next_frame(() => ref_text_area.current.focus());
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return is_loading || g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_bar_line />;

  return (
    <div className="p-1 w-full">
      <UI_PRIMITIVE__text_area
        ref={ref_text_area}
        className="rounded-lg border-none px-4 !text-xs"
        placeholder={t(i18n_page_generation.sidebar_user_input.input.prompt_text_area.placeholder)}
        lineCount={35}
        value={input_value}
        {...{ onChange, onKeyDown }}
        disabled={is_disabled()}
      />
    </div>
  );
}
